export type DemoResetSchedule = {
  serverTimeMs: number
  receivedAtMs: number
  nextResetAtMs: number
}

export const getRemainingTimeMs = (
  schedule: DemoResetSchedule,
  clientNowMs: number,
): number =>
  Math.max(
    0,
    schedule.nextResetAtMs -
      (schedule.serverTimeMs +
        Math.max(0, clientNowMs - schedule.receivedAtMs)),
  )

export const formatCountdown = (remainingMs: number): string => {
  const totalSeconds = Math.ceil(Math.max(0, remainingMs) / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return [hours, minutes, seconds]
    .map((value) => String(value).padStart(2, '0'))
    .join(':')
}
